import React, { useCallback, useMemo, useState } from 'react';
import { Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import ResidueCollectedModal from '../Modals/ResidueCollectedModal';
import DeleteResidueCollectedModal from '../Modals/DeleteResidueCollectedModal';
import { Icons } from '../../../utils/Icons';

const ResiduesCollectedTab = ({
	residuesCollectedList,
	handleResiduesCollectedList
}) => {
	const [dataResidueCollected, setDataResidueCollected] = useState(null);
	const [isEdit, setIsEdit] = useState(false);
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);

	const handleClickEdit = useCallback((residueCollected) => {
		setIsEdit(true);
		setDataResidueCollected(residueCollected);
		handleToggleModal();
	}, []);

	const handleClickDelete = useCallback((residueCollected) => {
		setDataResidueCollected(residueCollected);
		handleToggleModalDelete();
	}, []);

	function handleToggleModal() {
		setModal(prev => !prev);
	}

	function handleToggleModalDelete() {
		setModalDelete(prev => !prev);
	}

	const handleCreateResidueCollected = useCallback(() => {
		setIsEdit(false);
		setDataResidueCollected({});
		handleToggleModal();
	}, []);

	const columns = useMemo(
		() => [
			{
				header: 'Acciones',
				enableSorting: false,
				enableColumnFilter: false,
				enableGlobalFilter: false,
				enableColumnActions: false,
				accessorKey: 'actions',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					const rowData = cellProps.row.original;
					return (
						<React.Fragment>
							<div className='d-flex justify-content-center'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												title={'Editar'}
												to='#'
												onClick={event => {
													event.preventDefault();
													handleClickEdit(rowData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												title={'Eliminar'}
												to='#'
												className='remove-item-btn'
												onClick={event => {
													event.preventDefault();
													handleClickDelete(rowData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Residuo', accessorKey: 'residue.name', size: 'auto' },
			{ header: 'Cantidad (kg)', accessorKey: 'kilograms', size: 'auto' },
			{ header: 'Tipo de origen', accessorKey: 'origin_type.name', size: 'auto' },
		],
		[handleClickDelete, handleClickEdit]
	);

	return (
		<React.Fragment>
			<Col lg={12}>
				<div className='mt-3 my-4'>
					<ODataGrid
						columns={columns}
						data={residuesCollectedList || []}
						customToolbarActions={[
							{
								label: 'Agregar',
								icon: Icons.plus,
								onClick: handleCreateResidueCollected,
								title: 'Agregar Residuo',
							}
						]}
					/>
				</div>
			</Col>
			<ResidueCollectedModal
				dataResidueCollected={dataResidueCollected}
				isOpen={modal}
				isEdit={isEdit}
				handleToggleModal={handleToggleModal}
				residuesCollectedList={residuesCollectedList}
				handleResiduesCollectedList={handleResiduesCollectedList}
			/>
			<DeleteResidueCollectedModal
				dataResidueCollected={dataResidueCollected}
				isOpen={modalDelete}
				handleToggleModal={handleToggleModalDelete}
				residuesCollectedList={residuesCollectedList}
				handleResiduesCollectedList={handleResiduesCollectedList}
			/>
		</React.Fragment>
	);
};

export default ResiduesCollectedTab;